var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 57.6334C79.2443 59.4184 77.8895 60.0021 76.0191 60C51.8851 59.966 27.7511 59.9745 3.61713 59.9851C2.46689 59.9851 1.44192 59.7432 0.688316 58.7986C-0.0256211 57.905 -0.217674 56.9308 0.270809 55.8398C1.72582 52.5923 3.17457 49.3427 4.58992 46.0783C4.81537 45.5582 5.15564 45.5667 5.57941 45.5667C17.7894 45.571 29.9994 45.5688 42.2094 45.5688C52.9101 45.5688 63.6087 45.5752 74.3094 45.554C74.944 45.554 75.255 45.7365 75.5201 46.3436C76.9835 49.6951 78.4991 53.0232 79.9979 56.3598V57.6312L80 57.6334ZM13.2657 51.2488H66.7337V49.5932H13.2657V51.2488ZM32.5566 55.982H47.4261V54.25H32.5566V55.982Z",
    fill: "url(#paint0_linear_2_1708)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1611 43.7434H4.83418V42.8902C4.83418 29.8365 4.83418 16.785 4.83418 3.73143C4.83626 1.30748 6.11175 0.00212254 8.49989 0C29.488 0 50.476 0 71.4641 0C73.8982 0 75.1611 1.29475 75.1611 3.776C75.1611 16.802 75.1611 29.8281 75.1611 42.8562C75.1611 43.1385 75.1611 43.4229 75.1611 43.7413V43.7434ZM10.2284 5.52073V38.2524H69.7815V5.52073H10.2284Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1708",
    x1: 24.065,
    y1: 10.7105,
    x2: 42.5307,
    y2: 56.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptops);
export default __webpack_public_path__ + "static/media/laptops.4f5fd573ee8008d813f8dbbfc41e7a64.svg";
export { ForwardRef as ReactComponent };